import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Page from 'Common/Layout/Page';
import CloseButton from '../../../../../Common/CloseButton/CloseButton';
import AppointeeDatatable from '../../Datatable/AppointeeDatatable';
import AppointeeColumns from '../../Columns/AppointeeColumns';
import APSAppointeeDataColumns from '../../Columns/APSAppointeeDataColumns';

import { getAPSAppointee, getAPSAppointeeExport, getAPSAppointeeDetails } from '../../../../../Redux/Actions/Appointee.Contract.Actions';
import classes from '../appointee-management.module.css';

import { withClsCompTracking } from '../../../../../Telemetry/telemetry.service';

const ApsAppointeeDataTable = withClsCompTracking('APS Appointee Data')(AppointeeDatatable);

const ApsAppointeeData = ({ handleActiveModal }) => {
	const dispatch = useDispatch();
	const qualification_year = useSelector(state => state.contract_globals.qualification_year.selected);
	const types = useSelector(state => state.contract_globals.appointment_types.selected);
	const { apiCallCompleted, appointeeData, appointeeDataDetails, appointeeDataExport } = useSelector(state => state.appointeeReducer);
	const handleGetAPSAppointee = (year, contractTypes, query) => dispatch(getAPSAppointee(year, contractTypes, query));
	const handleGetAPSAppointeeExport = (year, contractTypes, query) => dispatch(getAPSAppointeeExport(year, contractTypes, query));
	const handleGetAPSAppointeeDetails = (markingTeamId, year, markingTeamCode, contractTypes, query) =>
		dispatch(getAPSAppointeeDetails(markingTeamId, year, markingTeamCode, contractTypes, query));

	return (
		<>
			<Page title="APS Appointee Data">
			</Page>
			<ApsAppointeeDataTable
				mainKeyField={'markingTeamId'}
				detailsKeyField={'appointeeId'}
				mainColumns={AppointeeColumns()}
				detailsColumns={APSAppointeeDataColumns()}
				contractTypes={types}
				selectedYear={qualification_year}
				handleGetData={handleGetAPSAppointee}
				handleGetDataExport={handleGetAPSAppointeeExport}
				handleGetDataDetails={handleGetAPSAppointeeDetails}
				apiCallCompleted={apiCallCompleted}
				mainTableData={appointeeData}
				detailsTableData={appointeeDataDetails}
				mainExportData={appointeeDataExport}
				detailsExportData={appointeeDataDetails}
			/>
			<span className={classes['action-buttons']}>
				<CloseButton closeOnClick={() => handleActiveModal('')} />
			</span>
		</>
	);
};

export default ApsAppointeeData;
